module.exports = __webpack_public_path__ + "img/9.be3963d0.png";